import React from 'react'
import {colors} from '@/constants'
import TransCustom from '@/components/UI/i18next'

interface AcceptModalInterface {
  name: string
  description: string
  addDescription?: string
  params1?: {[key: string]: string | number}
  params2?: {[key: string]: string | number}
  params3?: {[key: string]: string | number}
}

const Index = ({name, description, addDescription, params1, params2, params3}: AcceptModalInterface) => {

  return (
    <>
      <TransCustom
        i18nKey={name}
        variant="h1"
        params={params1}
        style={{wordBreak: 'break-word'}}
        color={colors.yellow}
        textAlign="center" />
      <TransCustom
        i18nKey={description}
        variant="body1"
        params={params2}
        style={{wordBreak: 'break-word'}}
        color={colors.white}
        textAlign="center" />
      {addDescription && (
        <TransCustom
          i18nKey={addDescription}
          params={params3}
          style={{fontSize: '12px', wordBreak: 'break-word'}}
          color={colors.gray}
          fontWeight="400" />
      )}
    </>
  )
}

export default React.memo(Index)
